
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M5.503 7.504h6.005M5.501 10.503h3.997"}}),_c('path',{attrs:{"stroke":"#798F8F","d":"M8 2.039a1 1 0 0 1 1 0l5.062 2.922a1 1 0 0 1 .5.866v5.846a1 1 0 0 1-.5.866L9 15.46a1 1 0 0 1-1 0L2.938 12.54a1 1 0 0 1-.5-.866V5.827a1 1 0 0 1 .5-.866z"}})])
          )
        }
      }
    